import { FC } from "react"

import { ThemeEnum, TThemeStyles } from "domain/customization/types"

import EurIcon from "./icons/EUR.svg"
import EthIcon from "./icons/ETH.svg"
import CardIcon from "./icons/BANKCARD.svg"
import * as S from "./styled"

type TMainWidgetPageProps = {
  config: TThemeStyles
  theme: ThemeEnum
}

export const MainWidgetPage: FC<TMainWidgetPageProps> = ({ config, theme }) => {
  const firstTextColor = theme === ThemeEnum.Light ? "#000000" : "#E5E5E5"
  const amountInpBorder = theme === ThemeEnum.Light ? "transparent" : "#404040"
  const amountInpSplit = theme === ThemeEnum.Light ? "#F2F2F2" : "#404040"
  const selectorBg = theme === ThemeEnum.Light ? "#F2F2F2" : "#262626"
  const baseAmountBorder = theme === ThemeEnum.Light ? "#E5E5E5" : "#404040"

  return (
    <S.Wrapp $color={config.secondaryBackground}>
      <S.Top $color={config.primaryBackground}>
        <S.TitleWrapp>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 7.00049H19M5 12.0005H19M5 17.0005H19"
              stroke="#808080"
            />
          </svg>
          <S.Title>Buying cryptocurrency</S.Title>
        </S.TitleWrapp>

        <S.CurrencyInput
          $color={config.secondaryBackground}
          $borderColor={amountInpBorder}
        >
          <S.CurrencyInputLeft $borderColor={amountInpSplit}>
            <S.CurrencyInputLabel>
              You pay{" "}
              <svg
                width="9"
                height="8"
                viewBox="0 0 9 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.201705 4.24574L1.21591 3.21875L3.28267 5.25142L7.75284 0.798295L8.77557 1.82528L3.28267 7.29688L0.201705 4.24574Z"
                  fill="#346BD7"
                  className="fill"
                />
              </svg>
            </S.CurrencyInputLabel>
            <S.CurrencyInputAmount $color={firstTextColor}>
              100.00
            </S.CurrencyInputAmount>
          </S.CurrencyInputLeft>
          <S.CurrencyInputRight $color={firstTextColor}>
            <img src={EurIcon} alt="EUR" />
            <S.CurrencyInputValue>EUR</S.CurrencyInputValue>
          </S.CurrencyInputRight>
        </S.CurrencyInput>

        <S.RateBlock $color={firstTextColor}>
          <div>
            1 ETH <span style={{ position: "relative", top: "-2px" }}>≈</span>{" "}
            1732.36 EUR
          </div>
          <S.RateBlockCounter>
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 5C9.5 5.89002 9.23608 6.76004 8.74161 7.50007C8.24715 8.24009 7.54434 8.81686 6.72208 9.15746C5.89981 9.49805 4.99501 9.58717 4.12209 9.41353C3.24918 9.2399 2.44736 8.81132 1.81802 8.18198C1.18868 7.55264 0.7601 6.75082 0.586466 5.87791C0.412833 5.00499 0.501948 4.10019 0.842542 3.27792C1.18314 2.45566 1.75991 1.75285 2.49993 1.25839C3.23996 0.76392 4.10998 0.5 5 0.5"
                stroke="#808080"
              />
            </svg>
            <span>Valid for 10s</span>
          </S.RateBlockCounter>
        </S.RateBlock>

        <S.CurrencyInput
          $color={config.secondaryBackground}
          $borderColor={amountInpBorder}
        >
          <S.CurrencyInputLeft $borderColor={amountInpSplit}>
            <S.CurrencyInputLabel>You get</S.CurrencyInputLabel>
            <S.CurrencyInputAmount $color={firstTextColor}>
              0.0530859
            </S.CurrencyInputAmount>
          </S.CurrencyInputLeft>
          <S.CurrencyInputRight $color={firstTextColor}>
            <img src={EthIcon} alt="ETH" />
            <S.CurrencyInputValue>ETH</S.CurrencyInputValue>
          </S.CurrencyInputRight>
        </S.CurrencyInput>
      </S.Top>

      <S.MethodBlock>
        <S.MethodBlockLabel>Payment method</S.MethodBlockLabel>
        <S.MethodSelector $bg={selectorBg}>
          <img src={CardIcon} alt="Card" />
          <S.MethodSelectorLabel>Bank card</S.MethodSelectorLabel>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="t-selectMethod-icon"
          >
            <path d="M8 6L12 10L8 14" stroke="#808080" strokeLinejoin="round" />
          </svg>
        </S.MethodSelector>
      </S.MethodBlock>

      <S.BaseAmount $color={firstTextColor} $border={baseAmountBorder}>
        <div>
          <span>€99.78</span> all fees includes
        </div>
        <S.BaseAmountOpenLink $color={config.secondaryColor}>
          Less
        </S.BaseAmountOpenLink>
      </S.BaseAmount>

      <S.CommissionRaw $color={firstTextColor}>
        <div>0.05304707 ETH</div>
        <div>€91.79</div>
      </S.CommissionRaw>
      <S.CommissionRaw $color={firstTextColor}>
        <div>
          Processing fee{" "}
          <svg width="26" height="26" viewBox="0 0 26 26" fill="#808080">
            <path d="M13.625 10C13.625 9.65482 13.3452 9.375 13 9.375C12.6548 9.375 12.375 9.65482 12.375 10H13.625ZM12.375 10.015C12.375 10.3602 12.6548 10.64 13 10.64C13.3452 10.64 13.625 10.3602 13.625 10.015H12.375ZM12.375 10V10.015H13.625V10H12.375ZM12.375 11.5V16H13.625V11.5H12.375ZM13 19.875C9.20304 19.875 6.125 16.797 6.125 13H4.875C4.875 17.4873 8.51269 21.125 13 21.125V19.875ZM19.875 13C19.875 16.797 16.797 19.875 13 19.875V21.125C17.4873 21.125 21.125 17.4873 21.125 13H19.875ZM13 6.125C16.797 6.125 19.875 9.20304 19.875 13H21.125C21.125 8.51269 17.4873 4.875 13 4.875V6.125ZM13 4.875C8.51269 4.875 4.875 8.51269 4.875 13H6.125C6.125 9.20304 9.20304 6.125 13 6.125V4.875Z" />
          </svg>
        </div>
        <div>€7.99</div>
      </S.CommissionRaw>
      <S.CommissionRaw $color={firstTextColor}>
        <div>
          Network fee{" "}
          <svg width="26" height="26" viewBox="0 0 26 26" fill="#808080">
            <path d="M13.625 10C13.625 9.65482 13.3452 9.375 13 9.375C12.6548 9.375 12.375 9.65482 12.375 10H13.625ZM12.375 10.015C12.375 10.3602 12.6548 10.64 13 10.64C13.3452 10.64 13.625 10.3602 13.625 10.015H12.375ZM12.375 10V10.015H13.625V10H12.375ZM12.375 11.5V16H13.625V11.5H12.375ZM13 19.875C9.20304 19.875 6.125 16.797 6.125 13H4.875C4.875 17.4873 8.51269 21.125 13 21.125V19.875ZM19.875 13C19.875 16.797 16.797 19.875 13 19.875V21.125C17.4873 21.125 21.125 17.4873 21.125 13H19.875ZM13 6.125C16.797 6.125 19.875 9.20304 19.875 13H21.125C21.125 8.51269 17.4873 4.875 13 4.875V6.125ZM13 4.875C8.51269 4.875 4.875 8.51269 4.875 13H6.125C6.125 9.20304 9.20304 6.125 13 6.125V4.875Z" />
          </svg>
        </div>
        <div>€0.00</div>
      </S.CommissionRaw>

      <S.SubmitBtnWrapp>
        <S.SubmitBtn $bg={config.primaryColor} $color={config.primaryTextColor}>
          Continue
        </S.SubmitBtn>
      </S.SubmitBtnWrapp>
    </S.Wrapp>
  )
}
